module.exports = __webpack_public_path__ + "img/Flow-Outline.86b33fba.png";